<template>
    <div style="display: contents">

        <button @click="openDialog()">
            <span><svg class="camera-alt"><use xlink:href="#camera-alt"></use></svg></span>
            Upload Cover Image
        </button>

        <!-- Fake Input File -->
        <input type="file"
               id="cover"
               :ref="fileInputId"
               @change="handleCoverUpload()"
               accept="image/jpg, image/jpeg, image/png"
               style="display: none;"/>

    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers'

export default {

    mixins: [Helpers],

    props: ['value'],

    data() {
        return {
            fileInputId: 'cover_' + this._uid,
            currentList: this.value,
        }
    },

    methods: {

        openDialog() {
            eventBus.$emit('set-all-list-inactive');
            this.$refs[this.fileInputId].click();
            this.$emit('input', this.currentList)
        },

        handleCoverUpload() {
            const file = this.$refs[this.fileInputId].files[0];

            if (!file) return

            let filesize = this.getFileSize(this.$refs[this.fileInputId].files[0])

            if (filesize > 10) {
                alert('The list cover picture may not be greater than 10MB.')
                return;
            }

            let formData = new FormData();
            formData.append('cover', file, file.name)

            this.$emit('uploading-cover', true);
            this.$emit('input', this.currentList)

            axios.post(`/lists/${this.currentList.id}/cover`, formData)
                .then((response) => {
                    this.$emit('uploading-cover', false);
                    this.currentList = response.data.list
                    this.$emit('input', this.currentList)
                })
                .catch(errors => {
                    this.$emit('uploading-cover', false);
                    this.$emit('input', this.currentList)
                })
        },
    }
}
</script>
